/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cloud_logic_custom": [
        {
            "name": "generalAPI",
            "endpoint": "https://zqf15cuz02.execute-api.ap-southeast-2.amazonaws.com/main",
            "region": "ap-southeast-2"
        },
        {
            "name": "marketingApi",
            "endpoint": "https://enm4poqy2e.execute-api.ap-southeast-2.amazonaws.com/main",
            "region": "ap-southeast-2"
        },
        {
            "name": "paymentsAPI",
            "endpoint": "https://b9nn2pwlck.execute-api.ap-southeast-2.amazonaws.com/main",
            "region": "ap-southeast-2"
        },
        {
            "name": "paypalAPI",
            "endpoint": "https://wjohg76p4f.execute-api.ap-southeast-2.amazonaws.com/main",
            "region": "ap-southeast-2"
        },
        {
            "name": "stripeApi",
            "endpoint": "https://8mvwv19q0j.execute-api.ap-southeast-2.amazonaws.com/main",
            "region": "ap-southeast-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://r2aahbg275dkvgsbfooa7n7xc4.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-xijnfunywzdwxmqo3aksaep6ia",
    "aws_cognito_identity_pool_id": "ap-southeast-2:3f3efe44-9d52-4ab5-a362-b3e9b953ba14",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_8tk9c6Pum",
    "aws_user_pools_web_client_id": "3920d2oma1pk6jlponvn96qrsg",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
